import React from "react";

const SvgArrowRed = props => (
  <svg width="1em" height="1em" viewBox="0 0 151.685 112.79" fill="currentColor" {...props} >
    <path
      d="M138.552 43.245H46.364a3.874 3.874 0 01-1.253 0c-.035-.019-.123 0-.166 0l17.567-17.567 2.977-2.978a13.484 13.484 0 003.993-8.063A13.306 13.306 0 0054.036.205c-3.647.656-6.17 2.852-8.661 5.342l-7.658 7.656-22.3 22.3-8.667 8.665a34.8 34.8 0 00-4.583 4.948c-3.646 5.473-2.491 12.409 1.99 16.958 1.837 1.866 3.7 3.7 5.557 5.556l21.75 21.745 15.341 15.339a13.339 13.339 0 0018.177.942 13.28 13.28 0 004.44-11.938 13.582 13.582 0 00-4-7.643q-9.3-9.333-18.635-18.635l-1.84-1.84h93.026a13.525 13.525 0 0011.864-6.381 13.3 13.3 0 00-5.976-18.854 13.163 13.163 0 00-5.309-1.12z"
      data-name="Path 166"
    />
  </svg>
);

export default SvgArrowRed;

